"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4111],{

/***/ 14111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FooterBarB": function() { return /* reexport */ FooterBarB; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./src/contexts/CursorContext/Cursor.tsx
var Cursor = __webpack_require__(52746);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
;// CONCATENATED MODULE: ./src/components/FooterBarB/@editor/index.ts


var useEditorHandlers = function(name) {
    var theme = (0,useTheme/* default */.Z)();
    return (0,Cursor/* useCursorHandlers */.h)({
        name: name,
        styles: [
            {
                name: "theme_component_footer_color",
                label: "Text color",
                type: "color",
                default: theme.palette.primary.contrastText
            },
            // {
            //   name: 'theme_component_footer_link_color',
            //   label: 'Link color',
            //   type: 'color',
            //   default: theme.palette.primary.contrastText,
            // },
            {
                name: "theme_component_footer_background_color",
                label: "Background color",
                type: "color",
                default: theme.palette.primary.main
            }, 
        ],
        configuration: [
            // {
            //   name: 'component_footer_bar_made_by_disabled',
            //   label: 'Made-by Azerion mini footer disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            // {
            //   name: 'component_footer_bar_privacy_url_disabled',
            //   label: 'Privacy statement URL disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            {
                name: "component_advertisement_show",
                label: "Show Sticky Advertisement",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_azerion_footer",
                label: "Azerion branded footer visible",
                type: "checkbox",
                default: false
            },
            {
                name: "component_footer_bar_privacy_url",
                label: "Privacy statement URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            // {
            //   name: 'component_footer_bar_terms_url_disabled',
            //   label: 'Terms and agreements URL disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            {
                name: "component_footer_bar_terms_url",
                label: "Terms and agreements URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            // {
            //   name: 'component_footer_bar_cookies_url_disabled',
            //   label: 'Cookie statement URL disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            {
                name: "component_footer_bar_cookies_url",
                label: "Cookie statement URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            },
            // {
            //   name: 'component_footer_bar_help_center_url_disabled',
            //   label: 'Help center URL disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            // {
            //   name: 'component_footer_bar_help_center_url',
            //   label: 'Help center URL',
            //   type: 'text',
            //   helperText: 'Only supply a URL if you want to link towards a different site.',
            // },
            // {
            //   name: 'component_footer_bar_contact_url_disabled',
            //   label: 'Contact URL disabled',
            //   type: 'checkbox',
            //   default: false,
            // },
            {
                name: "component_footer_bar_contact_url",
                label: "Contact URL",
                type: "text",
                helperText: "Only supply a URL if you want to link towards a different site."
            }, 
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(29769);
// EXTERNAL MODULE: ./src/contexts/HighlightContext/Highlight.tsx
var Highlight = __webpack_require__(78958);
// EXTERNAL MODULE: ./src/contexts/AppContext/index.tsx + 6 modules
var AppContext = __webpack_require__(13560);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./src/components/Link/index.tsx
var Link = __webpack_require__(7500);
// EXTERNAL MODULE: ./src/components/ImageLoaderWrapper/index.ts + 2 modules
var ImageLoaderWrapper = __webpack_require__(95073);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/index.ts

/**
 * Attempts to open the OneTrust cookie preferences panel.
 * Prevents default link behaviour if event is provided.
 */ var handleCookieClick = function(event) {
    try {
        var ref, ref1;
        event === null || event === void 0 ? void 0 : event.preventDefault();
        window === null || window === void 0 ? void 0 : (ref = window.OneTrust) === null || ref === void 0 ? void 0 : (ref1 = ref.ToggleInfoDisplay) === null || ref1 === void 0 ? void 0 : ref1.call(ref);
    } catch (error) {
        console.error("OneTrust.ToggleInfoDisplay() failed:", error);
    }
};
/**
 * Generate a random, Base-36, fixed 10-character string (eg: "hdjl39jkf1").
 */ var generateRandomId = function() {
    return Math.random().toString(36).slice(2, 12).padEnd(10, "0");
};

;// CONCATENATED MODULE: ./src/components/FooterBarB/FooterBarB.tsx
















var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv20"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "column"
    };
});
var Root = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv21"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: "auto",
        color: theme.theme_component_footer_color || "#B0B1B7",
        "& a": {
            color: "inherit",
            textDecoration: "none"
        },
        "& h3": (0,_define_property/* default */.Z)({
            color: theme.theme_component_footer_h3_color || "#83ae30",
            marginBottom: theme.spacing(1)
        }, theme.breakpoints.up("md"), {
            marginBottom: theme.spacing(0.5)
        })
    };
});
var Grid = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv22"
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gridTemplateRows: "1fr",
        gridColumnGap: theme.spacing(2),
        gridRowGap: theme.spacing(2),
        padding: theme.spacing(4),
        backgroundColor: theme.theme_component_footer_background_color || "#000000"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.between("sm", "md"), {
        gridTemplateColumns: "repeat(2, 1fr)",
        "& > div:first-of-type": {
            gridColumn: "span 2"
        },
        "& > div:nth-child(2)": {
            gridColumn: "span 2"
        }
    }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("lg"), {
        gridTemplateColumns: "1fr 2fr repeat(2, 1fr)"
    }), _obj;
});
var GridItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv23"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        justifySelf: "center",
        textAlign: "center",
        overflow: "hidden",
        width: "100%"
    }, theme.breakpoints.up("sm"), {
        textAlign: "left",
        justifySelf: "stretch"
    });
});
var ButtonLogo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* default */.Z, {
    target: "e1tukwv24"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "block",
        width: "100%",
        height: "50px",
        margin: "auto"
    }, theme.breakpoints.up("lg"), {
        margin: "auto auto auto 0"
    });
});
var ImageLogo = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ImageLoaderWrapper/* ImageLoaderWrapper */.T, {
    target: "e1tukwv25"
})(function() {
    return {
        display: "block",
        width: "100%",
        height: "auto"
    };
});
var GridListContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv26"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        display: "grid",
        gridTemplateColumns: "repeat(1, 1fr)",
        gridTemplateRows: "1fr",
        gridColumnGap: theme.spacing(2),
        gridRowGap: 0
    }, theme.breakpoints.up("sm"), {
        gridTemplateColumns: "repeat(2, 1fr)"
    });
});
var List = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("ul", {
    target: "e1tukwv27"
})(function() {
    return {
        listStyle: "none",
        margin: 0,
        padding: 0
    };
});
var ListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "e1tukwv28"
})(function() {
    return {
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden"
    };
});
var GridListItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ListItem, {
    target: "e1tukwv29"
})(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        padding: theme.spacing(1, 0)
    }, theme.breakpoints.up("md"), {
        padding: 0
    });
});
var AzerionBrandContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv210"
})(function() {
    return {
        backgroundColor: "black",
        color: "white"
    };
});
var AzerionBrandContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1tukwv211"
})(function() {
    return {
        backgroundColor: "black",
        color: "white",
        marginLeft: 30,
        padding: "10px 0"
    };
});
var splitEvery = function(array, length) {
    return array.reduce(function(result, item, index) {
        if (index % length === 0) result.push([]);
        result[Math.floor(index / length)].push(item);
        return result;
    }, []);
};
var FooterBarB_Typography = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Typography/* default */.Z, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var FooterBarB_Link = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    return (0,Highlight/* useHighlightHandlers */.R)(Link/* Link */.r, (0,_object_spread/* default */.Z)({
        forwardedRef: ref
    }, props));
});
var FooterBarB = function() {
    var t = (0,esm/* useTranslation */.$G)("footer_bar_b").t;
    var appContext = (0,AppContext/* useAppContext */.bp)();
    var ref = appContext.useConfig(), url = ref.url, assetUrl = ref.assetUrl, footerLogoId = ref.footerLogoId, componentOptions = ref.componentOptions;
    var categories = appContext.useCategories().categories;
    var cookieManagementEnabled = componentOptions.component_footer_bar_cookie_management_enabled;
    var logoUrl = componentOptions.component_footer_bar_logo_url;
    var privacyUrl = componentOptions.component_footer_bar_privacy_url;
    var termsUrl = componentOptions.component_footer_bar_terms_url;
    var contactUrl = componentOptions.component_footer_bar_contact_url;
    var cookiesUrl = componentOptions.component_footer_bar_cookies_url;
    var azerionBrand = componentOptions === null || componentOptions === void 0 ? void 0 : componentOptions.component_footer_bar_azerion_footer;
    var categoriesHeaderRef = react.useRef(null);
    var infoHeaderRef = react.useRef(null);
    var contactUrlRef = react.useRef(null);
    var privacyUrlRef = react.useRef(null);
    var termsUrlRef = react.useRef(null);
    var cookiesUrlRef = react.useRef(null);
    var cookieManagementRef = react.useRef(null);
    var linkRefs = react.useRef([]);
    // Todo: Fix linkRefs.current typescript problem.
    // @ts-ignore
    linkRefs.current = categories.map(function(category, index) {
        var _index;
        // @ts-ignore
        return (_index = linkRefs.current[index]) !== null && _index !== void 0 ? _index : /*#__PURE__*/ react.createRef();
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, useEditorHandlers("Footer Bar B")), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridItem, {
                            children: footerLogoId && (logoUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonLogo, {
                                component: FooterBarB_Link,
                                href: logoUrl,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageLogo, {
                                    width: 200,
                                    height: 60,
                                    src: "".concat(assetUrl).concat(footerLogoId, "/"),
                                    alt: logoUrl,
                                    sizes: "200px",
                                    layout: "responsive"
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonLogo, {
                                component: FooterBarB_Link,
                                href: "/",
                                "aria-label": "Home",
                                title: url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                                    loader: function(param) {
                                        var src = param.src;
                                        return src;
                                    },
                                    layout: "fill",
                                    objectFit: "contain",
                                    unoptimized: true,
                                    src: "".concat(assetUrl).concat(footerLogoId, "/"),
                                    alt: url
                                })
                            }))
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridItem, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Typography, {
                                    ref: categoriesHeaderRef,
                                    variant: "h6",
                                    component: "h3",
                                    children: t("header_categories", "Categories")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListContainer, {
                                    children: categories && splitEvery(categories, 4).map(function(chunk, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(List, {
                                            children: chunk.map(function(category, i) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                        // @ts-ignore
                                                        ref: linkRefs.current[i + index * 4],
                                                        href: "/category/".concat(category.slug),
                                                        variant: "subtitle2",
                                                        underline: "hover",
                                                        title: category.name,
                                                        children: category.name
                                                    })
                                                }, category.id);
                                            })
                                        }, index);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GridItem, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Typography, {
                                    ref: infoHeaderRef,
                                    variant: "h6",
                                    component: "h3",
                                    children: t("header_info", "Info")
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(List, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                            children: contactUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: contactUrlRef,
                                                href: contactUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("contact", "Contact"),
                                                children: t("contact", "Contact")
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: contactUrlRef,
                                                href: "/contact",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("contact", "Contact"),
                                                children: t("contact", "Contact")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                            children: privacyUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: privacyUrlRef,
                                                href: privacyUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("privacy_statement", "Privacy statement"),
                                                children: t("privacy_statement", "Privacy statement")
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: privacyUrlRef,
                                                href: "/legal/privacy-statement",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("privacy_statement", "Privacy statement"),
                                                children: t("privacy_statement", "Privacy statement")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                            children: termsUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: termsUrlRef,
                                                href: termsUrl,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("terms_of_use", "Terms of use"),
                                                children: t("terms_of_use", "Terms of use")
                                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                ref: termsUrlRef,
                                                href: "/legal/terms-of-use",
                                                variant: "subtitle2",
                                                underline: "hover",
                                                title: t("terms_of_use", "Terms of use"),
                                                children: t("terms_of_use", "Terms of use")
                                            })
                                        }),
                                        cookieManagementEnabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                                    children: cookiesUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                        ref: cookiesUrlRef,
                                                        href: cookiesUrl,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        variant: "subtitle2",
                                                        underline: "hover",
                                                        title: t("cookie_statement", "Cookie statement"),
                                                        children: t("cookie_statement", "Cookie statement")
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                        ref: cookiesUrlRef,
                                                        href: "/legal/cookie-statement",
                                                        variant: "subtitle2",
                                                        underline: "hover",
                                                        title: t("cookie_statement", "Cookie statement"),
                                                        children: t("cookie_statement", "Cookie statement")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GridListItem, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterBarB_Link, {
                                                        ref: cookieManagementRef,
                                                        href: "/",
                                                        onClick: handleCookieClick,
                                                        underline: "hover",
                                                        variant: "subtitle2",
                                                        title: t("cookie_management", "Cookie management"),
                                                        children: t("cookie_management", "Cookie management")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })),
            azerionBrand && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContainer, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AzerionBrandContent, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                        src: "/images/azerion-brand.png",
                        loader: function(param) {
                            var src = param.src, width = param.width;
                            return "".concat(src, "?w=").concat(width || 180);
                        },
                        alt: "made-with-love",
                        height: "30",
                        width: "180"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/FooterBarB/index.ts



/***/ }),

/***/ 95073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ ImageLoaderWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/utils/is-valid-url.ts
var isValidUrl = function(url) {
    // Check if the url is a valid url or not.
    return /^https?:\/\//.test(url || "");
};

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/ImageLoaderWrapper.tsx







/**
 * Calculates the proper height of an image with a custom width, preserving the original aspect ratio.
 *
 * @param originalHeight
 * @param originalWidth
 * @param newWidth
 */ function determineNewHeight(originalHeight, originalWidth, newWidth) {
    return Math.ceil(originalHeight / originalWidth * newWidth);
}
var ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)((image_default()), {
    target: "epyx9ne0"
})(function(param) {
    var theme = param.theme;
    return {
        objectFit: "cover"
    };
});
var ImageLoaderWrapper = function(props) {
    var height = props.height, width = props.width, grayscale = props.grayscale, format = props.format, layout = props.layout, alt = props.alt, _rszHeight = props.rszHeight, rszHeight = _rszHeight === void 0 ? true : _rszHeight, other = (0,_object_without_properties/* default */.Z)(props, [
        "height",
        "width",
        "grayscale",
        "format",
        "layout",
        "alt",
        "rszHeight"
    ]);
    var loader = function(loaderProps) {
        var q = loaderProps.quality, w = loaderProps.width, src = loaderProps.src;
        // TODO: Check if the provided src is a valid url or not, if yes return it directly.
        var validUrl = isValidUrl(src.replace(/\/+$/, "").replace("/media/", ""));
        // Can find the query properties here;
        // https://gitlab.azerdev.com/huz.byorbit/huz-media/-/blob/master/src/asset/index.js
        // Todo: HUZ2ERA-1106 - Seems our media server won't allow us to resize webp assets by ratio operation.
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&ar[r]=${width}x${height}&ar[w]=${w}`;
        // let url = `${src.replace(/\/+$/, '')}/?qty=${q || 75}&fmt=${format || 'webp'}&rsz[w]=${w}`;
        var url = "".concat(src.replace(/\/+$/, ""), "/?fmt=").concat(format || "webp", "&rsz");
        // if (rszHeight) {
        //   url += `&rsz[h]=${determineNewHeight(height, width, w)}`;
        // }
        if (grayscale) url += "&gsc=".concat(grayscale);
        // TODO: Remove the conditional logic after updating all the existing sites.
        return validUrl && src.includes("https://media-aws-dev.byorbit.com") ? src.replace("/media/", "") : validUrl ? src.replace("/media/", "").replace(/\/+$/, "") : url;
    };
    // Make sure we don't pass width and height when layout is set to 'fill'. Refer to Next/image docs.
    return layout === "fill" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        layout: layout,
        loader: loader,
        height: "100%"
    })) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageContainer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
        alt: alt,
        width: width,
        height: height,
        loader: loader
    }));
};

;// CONCATENATED MODULE: ./src/components/ImageLoaderWrapper/index.ts



/***/ }),

/***/ 78958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useHighlightHandlers; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54794);







// Todo: Have a hard time setting the type for Component, as it can be Mui Typography or our own Link component.
var useHighlightHandlers = function(Component, props) {
    var enabledVariants = (0,_index__WEBPACK_IMPORTED_MODULE_1__/* .useHighlightContext */ .A)().enabledVariants;
    var forwardedRef = props.forwardedRef, variant = props.variant, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "forwardedRef",
        "variant"
    ]);
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var element = null;
    // Todo: Not sure how to resolve this missing current ts warning.
    // @ts-ignore
    if (forwardedRef && (forwardedRef === null || forwardedRef === void 0 ? void 0 : forwardedRef.current)) {
        // Todo: Not sure how to resolve this missing current ts warning.
        // @ts-ignore
        element = forwardedRef.current;
    }
    if (element && variant && Array.isArray(enabledVariants)) {
        if (enabledVariants.includes(variant)) {
            element.style.outline = "2px dotted ".concat(theme.palette.info.main);
            element.style.outlineOffset = "-2px";
            element.style.position = "relative";
            if (!element.querySelector(".typographyBadge")) {
                var badge = document.createElement("div");
                badge.classList.add("typographyBadge");
                badge.style.position = "absolute";
                badge.style.top = theme.spacing(-0.5);
                badge.style.right = theme.spacing(-0.5);
                badge.style.backgroundColor = theme.palette.info.main;
                badge.style.borderRadius = "".concat(theme.shape.borderRadius, "px");
                badge.style.color = theme.palette.info.contrastText;
                badge.style.fontSize = "10px";
                badge.style.lineHeight = "10px";
                badge.style.padding = theme.spacing(0.5, 1);
                badge.style.boxShadow = theme.shadows[1];
                badge.style.textTransform = "capitalize";
                badge.innerText = [
                    "contained",
                    "text",
                    "outlined"
                ].includes(variant) ? "button" : variant;
                element.appendChild(badge);
            }
        } else {
            var ref;
            element.style.outline = "unset";
            (ref = element.querySelector(".typographyBadge")) === null || ref === void 0 ? void 0 : ref.remove();
        }
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Component, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        variant: variant,
        ref: forwardedRef
    }));
};


/***/ })

}]);